export default {
  clients: {
    title:
      '<span style="font-style: italic;">Uma empresa sólida, com uma </span>longa <b class="font-black">trajetória e ampla experiência </b> <span style="font-style: italic;">com empresas referência do mercado de diversos segmentos.</span>',
  },
}
